import React, { useEffect } from 'react'
import { useLoggedInUser } from '@/hooks'
const Helpkit: React.FC = () => {
  const { locale } = useLoggedInUser()
  const localeToUse = locale === 'da_DK' ? 'staffhelpdk' : 'staffhelpen'

  useEffect(() => {
    const script = document.createElement('script')
    script.id = 'helpkit-widget'
    script.dataset.projectId = localeToUse
    script.src = 'https://www.helpkit.so/widget/script.js'
    script.async = true

    document.head.appendChild(script)

    return () => {
      // Cleanup when the component unmounts
      document.head.removeChild(script)
    }
  }, [])

  return null // This component doesn't render anything
}

export default Helpkit
